module.exports = __webpack_public_path__ + "img/5_31.cfe03a62.png";